import React from 'react'
import { Column, SortingRule } from 'react-table'
import { Link } from 'react-router-dom'

import Table from '../Table'
import { Experience } from '../../types/experiences'

type ExperiencesTableProps = {
  data: Experience[]
  onSortBy: (sortBy: SortingRule<Experience>[]) => void
}

const ExperiencesTable: React.FC<ExperiencesTableProps> = (props) => {
  const columns = React.useMemo<Column<Experience>[]>(
    () => [
      {
        id: 'title',
        Header: 'Title & User',
        accessor: ({ author, title }) => (
          <div className="text-sm leading-5">
            <span className="block truncate text-gray-900" style={{ width: 245 }}>
              {title}
            </span>
            <span className="block truncate text-gray-500" style={{ width: 245 }}>
              {author?.user?.displayName}
            </span>
          </div>
        ),
      },
      {
        id: 'placeName',
        Header: 'Location & Area',
        accessor: ({ place }) => (
          <div className="truncate text-sm leading-5">
            <span className="block truncate text-gray-900" style={{ width: 245 }}>
              {place.name}
            </span>
            <span className="block text-gray-500" style={{ width: 245 }}>
              {place.location.city}
            </span>
          </div>
        ),
      },
      {
        id: 'placeCustomerName',
        Header: 'Customer',
        accessor: ({ place }) => (
          <p style={{ width: 200 }} className="truncate text-gray-500">
            {place?.customer?.name}
          </p>
        ),
      },
      {
        id: 'evaluation',
        Header: 'Rating',
        accessor: ({ evaluation }) => {
          if (evaluation === 'NEGATIVE') {
            return <span className="tag negative-tag">Negative</span>
          } else if (evaluation === 'POSITIVE') {
            return <span className="tag positive-tag">Positive</span>
          } else {
            return <span className="tag alert-tag">Neutral</span>
          }
        },
      },
      {
        id: 'status',
        Header: 'Status',
        accessor: ({ isValidated, isVerified }) => {
          if (isValidated) {
            return <span className="tag positive-tag">Verified</span>
          }

          if (isVerified) {
            return <span className="tag positive-tag">At Location</span>
          }

          return <span className="tag alert-tag">Unverified</span>
        },
      },
      {
        id: 'createdAt',
        Header: 'Date',
        accessor: ({ createdAt }) => new Date(createdAt).toLocaleDateString('en-GB'),
      },
      {
        Header: ' ',
        disableSortBy: true,
        accessor: (experience) => (
          <Link className="text-link" to={`/experiences/${experience.id}`}>
            View
          </Link>
        ),
      },
    ],
    []
  )

  return <Table columns={columns} data={props.data} onSortBy={props.onSortBy} />
}

export default React.memo(ExperiencesTable)
